/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from '../item';
import { TabDescription } from '../tab-description';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { SystemInfo } from '../system-info';
import { TooltipItem } from '../tooltip-item';
import { PastedItemsInfo } from '../../../../../feature/src/lib/models/pasted-items-info';

export interface IAddFittingPanelFrameFacade {
  getDockedState(): SysqueElectricalState;
  getAddFittingState(): SysqueElectricalState;
  notifyGetFittingsListAction(system: string, value: string): Observable<Item[]>;
  notifyGetCategoryListAction(systemName: string): Observable<TabDescription[]>;
  selectCategories(): Observable<TabDescription[]>;
  updateLocalStorage(key: string, value: any): any;
  sendPopupRoutingAction(route: string, width: number, height: number): any;
  saveChanges(Fitting2Manage: string): void;
  resetFittingModeState(): void;
  resetManageState(): void;
  resetDockedState(): void;
  updateSystemList(): void;
  selectSystems(): Observable<SystemInfo[]>;
  getTooltipItemInfo(item: Item, category: string): TooltipItem[];
  getFittings(systemName: string, categoryName: string): Observable<Item[]>;
  executePasteItemsAction(replaceItems: PastedItemsInfo[]): void;
  checkForDuplicateItems(items: PastedItemsInfo[]): Promise<PastedItemsInfo[]>;
}

export const ADD_FITTING_PANEL_FRAME_FACADE_TOKEN = new InjectionToken<IAddFittingPanelFrameFacade>(
  'ADD_FITTING_PANEL_FRAME_FACADE_TOKEN'
);
